import { useState, useEffect } from 'react'

import { DSText } from '@vr/ds-react'
import { Controller, useWatch } from 'react-hook-form'

import { CollectProps } from './type'
import { Multi } from '@/components/select/multi'
import { usePickupAddressPointGetDetails } from '@/hooks/use-pickup-address-point-get-details'

const cardIssuanceOptions = {
  '0': 'postosDeColetasFornecedorPrimeiraVia',
  '1': 'postosDeColetasFornecedorSegundaVia'
}

export const Collect = ({ methods, accountKey, operator }: CollectProps) => {
  const [collectOptions, setCollectOptions] = useState(null)
  const { fetchDetails } = usePickupAddressPointGetDetails()

  const cardIssuance = useWatch({
    name: 'viaDosCartoes',
    control: methods.control
  })

  useEffect(() => {
    if (!cardIssuance?.value) {
      setCollectOptions(null)
      return
    }

    const optionKey = cardIssuanceOptions[cardIssuance.value]

    const collectOptionsRaw = operator[optionKey] ?? null
    if (collectOptionsRaw && typeof collectOptionsRaw === 'object') {
      const optionsArray = collectOptionsRaw.map(option => ({
        label: option.value,
        value: option.key
      }))

      setCollectOptions(optionsArray)
    } else {
      setCollectOptions(null)
    }
  }, [cardIssuance, operator])

  const loadOptions = () => {
    if (collectOptions) {
      return Promise.resolve({
        options: collectOptions,
        hasMore: false,
        additional: { page: 1 }
      })
    } else {
      return Promise.resolve({
        options: [],
        hasMore: false,
        additional: { page: 1 }
      })
    }
  }

  const handlePickupAddressPointChange = async (selectedValue: any) => {
    if (selectedValue?.value) {
      const details = await fetchDetails(selectedValue.value)
      if (details?.isSuccess && details.content) {
        methods.setValue('pickupAddressPointDetails', details.content)
      }
    }
  }

  return (
    <>
      <Controller
        key={accountKey}
        name='postoDeColeta'
        control={methods.control}
        rules={{
          required: 'Posto de coleta é obrigatório'
        }}
        render={({ field: { onChange, value } }) => {
          const handleChange = (selectedValue: any) => {
            onChange(selectedValue)
            handlePickupAddressPointChange(selectedValue)
          }

          return (
            <Multi
              isMulti={false}
              closeMenuOnSelect={true}
              value={value}
              onChange={handleChange}
              label='Posto de coleta*'
              loadOptions={loadOptions}
            />
          )
        }}
      />
      {typeof methods.formState.errors.postoDeColeta?.message === 'string' && (
        <DSText as='span' size='sm' weight='semibold' color='errorLight'>
          {methods.formState.errors.postoDeColeta.message}
        </DSText>
      )}
      <PickupAddressPointDetails methods={methods} />
    </>
  )
}

const PickupAddressPointDetails = ({ methods }: any) => {
  const pickupAddressPointDetails = useWatch({
    name: 'pickupAddressPointDetails',
    control: methods.control
  })

  if (!pickupAddressPointDetails) {
    return null
  }

  return (
    <div style={{ marginTop: '16px', padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
      <DSText as='p' weight='medium' size='sm' style={{ display: 'block', marginBottom: '8px' }}>
        {pickupAddressPointDetails.endereco}, {pickupAddressPointDetails.numero}, {pickupAddressPointDetails.bairro}, Cep {pickupAddressPointDetails.cep}, {pickupAddressPointDetails.cidade} - {pickupAddressPointDetails.estado}
      </DSText>
      {pickupAddressPointDetails.complemento && (
        <DSText as='p' weight='medium' size='sm' style={{ display: 'block' }}>
          {pickupAddressPointDetails.complemento}
        </DSText>
      )}
    </div>
  )
}
